(() => {
  const config = window.cvPerformance || {};
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function hydrateSecondaryImage(image) {
    if (!image || image.dataset.cvLoaded === 'true') return;
    const src = image.dataset.cvSrc;
    const srcset = image.dataset.cvSrcset;
    const reveal = () => image.classList.add('is-loaded');
    image.addEventListener('load', reveal, { once: true });
    if (srcset) image.srcset = srcset;
    if (src) image.src = src;
    image.dataset.cvLoaded = 'true';
    if (image.complete && image.naturalWidth > 1) reveal();
  }

  function hydrateCard(card) {
    if (!config.deferSecondaryImages || !supportsHover || !card) return;
    card.querySelectorAll('img.cv-deferred-secondary').forEach(hydrateSecondaryImage);
  }

  if (config.deferSecondaryImages && supportsHover) {
    document.addEventListener('pointerover', (event) => {
      hydrateCard(event.target.closest('.product-card-wrapper'));
    }, { passive: true, capture: true });

    document.addEventListener('focusin', (event) => {
      hydrateCard(event.target.closest('.product-card-wrapper'));
    }, true);
  }

  if (config.disableMobileAnimations && window.matchMedia('(max-width: 749px)').matches) {
    document.documentElement.classList.add('cv-motion-reduced-active');
    document.querySelectorAll('.scroll-trigger--offscreen').forEach((element) => {
      element.classList.remove('scroll-trigger--offscreen');
    });
  }
})();
